import { IntroScreenUIConfig } from "../../components/ui/intro-screen-ui";
import { SingleScenarioInfoConfig } from "../../components/ui/scenario-info-ui";
import GameManager from "../../cvp-webgames-core/GameManager";
import BaseScenarioPart from "../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { VideoSegmentItem, SingleVideoSegmentItem } from "../../cvp-webgames-core/VideoSegment/VideoSegmentItem";
import { PreCacheItem, SinglePreCacheItem, PrecacheItemType } from "../../cvp-webgames-core/pre-caching/pre-cache-item";
import { PageType } from "../../misc/tools";
import { GameBaseScenario } from "../GameBaseScenario";
import IncorrectPtAdmittedComponentsStep0Component from "./components/incorrect-pt-admitted-components-step0/incorrect-pt-admitted-components-step0";
import IncorrectPtAdmittedComponentsStep0Part1 from "./components/incorrect-pt-admitted-components-step0/incorrect-pt-admitted-components-step0-parts/incorrect-pt-admitted-components-step0-part1";
import IncorrectPtAdmittedComponentsStep1Component from "./components/incorrect-pt-admitted-components-step1/incorrect-pt-admitted-components-step1";
import IncorrectPtAdmittedComponentsStep1Part1 from "./components/incorrect-pt-admitted-components-step1/incorrect-pt-admitted-components-step1-parts/incorrect-pt-admitted-components-step1-part1";
import IncorrectPtAdmittedComponentsStep2Component from "./components/incorrect-pt-admitted-components-step2/incorrect-pt-admitted-components-step2";
import IncorrectPtAdmittedComponentsStep2Part1 from "./components/incorrect-pt-admitted-components-step2/incorrect-pt-admitted-components-step2-parts/incorrect-pt-admitted-components-step2-part1";

class Scenario3IncorrectPtAdmittedVideoSegments extends VideoSegmentItem {
	public get title(): string {
		return 'Scenario 3 Incorrect Pt Admitted';
    }
	public getItems(): SingleVideoSegmentItem[] {
		return [
			{
				key: 'Scenario 3 Video 1',
				src: process.env.PUBLIC_URL + '/assets/videos/scenario03/sc03-cinematic/cin-sc-3.mp4',
				chapterIds: [
					'Chapter 1'
				]
			},
			{
				key: 'MixedMedia',
				src: process.env.PUBLIC_URL + '/assets/videos/scenario03/sc03-mentor/mntr-sc-03.mp4', //change this
				chapterIds: [
					'step-2'// alan to update premiere file with audios lol at the end of the time code.
				]
			},
			{
				key: 'Feedback',
				src: process.env.PUBLIC_URL + '/assets/videos/scenario03/sc03-mentor/mntr-sc-03.mp4', // change this
				chapterIds: [
					'scenario3-4', //question 1 correct
					'scenario3-3', //question 1 incorrect
					'scenario3-5', //question 1 other option - don't delete comment!
					'scenario3-8',//question 2 correct - don't delete comment!
					'scenario3-7', //question 2 incorrect - don't delete comment!
					'scenario3-9', //question 2 other option - don't delete comment!
					'scenario3-12', //question 3 correct - don't delete comment!
					'scenario3-13', //question 3 incorrect - don't delete comment!
					'scenario3-16', //question 4 correct - don't delete comment!
					'scenario3-15', //question 4 incorrect - don't delete comment!
					'scenario3-17', //question 4 other option - don't delete comment!
					'scenario3-20', //question 5 correct - don't delete comment!
					'scenario3-19', //question 5 incorrect - don't delete comment! 
					'scenario3-1', //scenario info 
					'scenario3-21' //scenario review 
				]
			}
		];
	}
}

export const scenario3IncorrectPtAdmittedVideoSegments = new Scenario3IncorrectPtAdmittedVideoSegments();

class Scenario3IncorrectPtAdmittedAudioCaching extends PreCacheItem {
    public audioKeys = {
        question1: 'question1',
        question2: 'question2',
        question3: 'question3',
        question4: 'question4',
        question5: 'question5'
    };
	public getItems(): SinglePreCacheItem[] {
		return [
			{
				type: PrecacheItemType.Audio,
				key: this.audioKeys.question1,
				src: process.env.PUBLIC_URL + '/assets/voiceover/scenario-03/mentor/jcdst-mentor-vo-scn-03-09.mp3'
			},
			{
				type: PrecacheItemType.Audio,
				key: this.audioKeys.question2,
				src: process.env.PUBLIC_URL + '/assets/voiceover/scenario-03/mentor/jcdst-mentor-vo-scn-03-14.mp3'
			},
			{
				type: PrecacheItemType.Audio,
				key: this.audioKeys.question3,
				src: process.env.PUBLIC_URL + '/assets/voiceover/scenario-03/mentor/jcdst-mentor-vo-scn-03-20.mp3'
			},
			{
				type: PrecacheItemType.Audio,
				key: this.audioKeys.question4,
				src: process.env.PUBLIC_URL + '/assets/voiceover/scenario-03/mentor/jcdst-mentor-vo-scn-03-24.mp3'
			},
			{
				type: PrecacheItemType.Audio,
				key: this.audioKeys.question5,
				src: process.env.PUBLIC_URL + '/assets/voiceover/scenario-03/mentor/jcdst-mentor-vo-scn-03-29.mp3'
			}
		];
	}
}

export const scenario3IncorrectPtAdmittedAudioCaching = new Scenario3IncorrectPtAdmittedAudioCaching();

export default class Scenario3IncorrectPtAdmitted extends GameBaseScenario {
	public comp1Step1FirstSelectedChoiceIndex: number = -1;
	public getMentorVideoURLs(): SingleVideoSegmentItem[] {
		return [
			scenario3IncorrectPtAdmittedVideoSegments.getItemByKey('MixedMedia'),
			scenario3IncorrectPtAdmittedVideoSegments.getItemByKey('Feedback'),
		] 
	}
	public getScenarioInfo(): SingleScenarioInfoConfig {
		return {
			scenarioId: PageType.Scenario3IncorrectPtAdmitted,
			title: 'Breach of Confidentiality',
			subtitle: 'Situation/Background',
			img: process.env.PUBLIC_URL + '/assets/images/scenarios/sample-image.png',
			description: `
				<p class="small-text" style="margin: 20px; text-align: center">
				After this learning activity you will be able to apply the Just Culture Decision Support Tool after an adverse event occurs.
				
				Breach of confidentiality and privacy, medical records released to incorrect patient.  

				Patient Cathy Anderson arrives to the medical records department to pick-up documents needed for an 
				appointment later that day; she is worried and pursuing a second opinion at another facility for a 
				lesion suspicious for cancer. There are two files ready for patient pick-up under the name Cathy, 
				a file for Cathy Anderson and one for Cathy Anders. Prior to the release of medical records, facility 
				protocol requires verification of patient identity utilizing a photo ID or similar documentation. This 
				day, the clerk is working alone due to a staffing shortage in her department, and there are many document 
				requests still to be gathered for upcoming pick-ups. In a rush to move through the line of patients awaiting 
				their files, the clerk asks each patient their name and skips the identification check. Cathy Anderson tells 
				the clerk her full name, the clerk quickly glances at the files and unknowingly hands over the file for Cathy 
				Anders. Cathy is concerned with her potential cancerous lesion and doesn’t notice the documents are for another 
				patient. Later that day at the appointment, Cathy Anderson recognized she did not have her records and immediately 
				called to inform the medical records supervisor that she was given the complete medical history for another patient. 
				What the medical records clerk didn’t know was that Cathy Anderson needed these documents for her second opinion 
				appointment that day and without them, would be forced to reschedule the appointment leaving the potentially cancerous 
				lesion in its place for longer than anticipated.
				</p>
			`,
			mentorVideoUrl: scenario3IncorrectPtAdmittedVideoSegments.getItemByKey('Feedback').src,
			mentorChapterId: scenario3IncorrectPtAdmittedVideoSegments.getItemByKey('Feedback').chapterIds[13]
		}
    }
	public resumeScenarioFromArea(areaIndx: number): void {
		switch(areaIndx) {
			case 0:
				(this.step0Component.parts[0] as IncorrectPtAdmittedComponentsStep0Part1).section2();
				break;
			case 1:
				(this.step0Component.parts[0] as IncorrectPtAdmittedComponentsStep0Part1).section3();
				break;
			case 2:
				(this.step1Component.parts[0] as IncorrectPtAdmittedComponentsStep1Part1).section2();
				break;
			case 3:
				(this.step1Component.parts[0] as IncorrectPtAdmittedComponentsStep1Part1).section3();
				break;
			case 4:
				(this.step2Component.parts[0] as IncorrectPtAdmittedComponentsStep2Part1).section1();
				break;
			case 5:
				(this.step2Component.parts[0] as IncorrectPtAdmittedComponentsStep2Part1).section2();
				break;
			case 6:
				(this.step1Component.parts[0] as IncorrectPtAdmittedComponentsStep1Part1).section1();
				break;
		}
	}

	//VALUES BELOW ARE FOR DEBUG PURPOSES IN CASE STEP 1 is SKIPPED
	// public comp1Step1FirstSelectedChoiceIndex: number = 0;
	public scenarioId(): PageType {
		return PageType.Scenario3IncorrectPtAdmitted;
    }

	private video: SingleVideoSegmentItem = scenario3IncorrectPtAdmittedVideoSegments.getItemByKey('Scenario 3 Video 1');
	public getScenarioVideoURL(): string {
		return this.video.src;
	}
	public introScreenInfo(): IntroScreenUIConfig {
		return {
		title: 'Breach of Confidentiality',
		subtitle: 'Incident Report',
		name: 'Rose',
		position: 'Medical Records Clerk',
		time: '9:00 am',
		place: 'Medical Records',
		desc: `Breach of confidentiality and privacy, medical records released to incorrect patient.`,
		repeat: 'No',
		okButton: 'Continue'
		}
	}

	private step0Component = new IncorrectPtAdmittedComponentsStep0Component({
		scenario: this,
		onDone: () => {
			this.goToStep1Component();
		}
	})

	private step1Component = new IncorrectPtAdmittedComponentsStep1Component({
		scenario: this,
		onDone: () => {
			this.goToStep2Component();
		}
	})

	private step2Component = new IncorrectPtAdmittedComponentsStep2Component({
		scenario: this,
		onDone: () => {
			this.uiWrapper.displayAAR();
		}
	})

	private parts: BaseScenarioPart<GameBaseScenario>[] = [].concat(this.step0Component.parts)
		.concat(this.step1Component.parts)
		.concat(this.step2Component.parts);

	constructor(gameManager: GameManager, scenarioName: string) {
		super(gameManager, scenarioName);
		this._setupStep0Component();
		this._setupStep1Component();
		this._setupStep2Component();
	}

	start() {
		this.goToStep0Component();
	}

	private _setupStep0Component() {
		this.step0Component.config.part1Config = {
			chapter: () => {
				return this.video.chapterIds[0];
			},
			videoUrl: this.video.src
		}
	}

	private _setupStep1Component() {
		this.step1Component.config.part1Config = {
			chapter: () => {
				return this.video.chapterIds[0];
			},
			videoUrl: this.video.src
		}
	}

	private _setupStep2Component() {
		this.step2Component.config.part1Config = {
			videoUrl: this.video.src
		}
	}

	public getParts(): BaseScenarioPart<GameBaseScenario>[] {
		return this.parts;
	}

	public getSoundPath(fileName: string): string {
		return process.env.PUBLIC_URL + '/assets/audio/scenario1/' + fileName + '.ogg';
	}

	goToStep0Component() {
		this.step0Component.start();
	}

	goToStep1Component() {
		this.step1Component.start();
	}

	goToStep2Component() {
		this.step2Component.start();
	}
}